import Tabs from "@/components/Tabs";
import KbvBangKeo from "../BangKeo";
import { BangXepHangPage } from "@/components/BangXepHang";
import KbvTiLe from "../KbvTiLe";

const KeoBongVipPlugin = ({ activeTab = "all", hideHeader = false }) => {
  return (
    <div className="w-full mx-auto">
      <Tabs
        tabs={[
          { id: "all", label: "Bảng Kèo", children: <KbvBangKeo /> },
          { id: "ketqua", label: "Kết Quả", children: <KbvBangKeo type="ketqua" /> },
          { id: "home", label: "Tỉ Lệ", children: <KbvTiLe /> },
          { id: "bang-xep-hang", label: "Bảng Xếp Hạng", children: <BangXepHangPage /> },
        ]}
        activeTab={activeTab}
        defaultTab="all"
        hideHeader={hideHeader}
      />
    </div>
  );
};

export default KeoBongVipPlugin;